import React from 'react';
import Table from 'components/Table';

const RichTextTable = ({ fields, ...otherProps }) => {
  const tableData = fields?.tableData && fields?.tableData['en-US'];
  const columns = fields?.columns && fields?.columns['en-US'];
  const zebra = fields?.zebra && fields?.zebra['en-US'];

  return (
    <Table {...otherProps} columns={columns} tableData={tableData} zebra={zebra} margin="50px 0" />
  );
};

export default RichTextTable;
